"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Enum;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Enum(name) {
  return new _enum(name);
}

var _enum = exports._enum = function _enum(name) {
  _classCallCheck(this, _enum);

  this.name = name;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVudW0uanMiXSwibmFtZXMiOlsiRW51bSIsIm5hbWUiLCJfZW51bSJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBQXdCQSxJOzs7O0FBQVQsU0FBU0EsSUFBVCxDQUFjQyxJQUFkLEVBQW9CO0FBQ2pDLFNBQU8sSUFBSUMsS0FBSixDQUFVRCxJQUFWLENBQVA7QUFDRDs7SUFFWUMsSyxXQUFBQSxLLEdBQ1gsZUFBWUQsSUFBWixFQUFrQjtBQUFBOztBQUNoQixPQUFLQSxJQUFMLEdBQVlBLElBQVo7QUFDRCxDIiwiZmlsZSI6ImVudW0uanMiLCJzb3VyY2VSb290IjoiL1VzZXJzL3RoYW5pc2gvR2l0aHViL21ubXRhbmlzaC9ncmFwaHFsaWZ5L3NyYyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEVudW0obmFtZSkge1xuICByZXR1cm4gbmV3IF9lbnVtKG5hbWUpO1xufVxuXG5leHBvcnQgY2xhc3MgX2VudW0ge1xuICBjb25zdHJ1Y3RvcihuYW1lKSB7XG4gICAgdGhpcy5uYW1lID0gbmFtZTtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../node_modules/graphqlify/lib/enum.js
// module id = 328
// module chunks = 46 47